<template>
    <div>
        <loading
            :active.sync="loader.isLoading"
            :can-cancel="loader.canCancel"
            :is-full-page="loader.fullPage"
            :color="loader.color"
            :height="loader.height"
            :width="loader.width"
            :background-color="loader.backgroundColor"
            :loader="loader.loader">
            </loading>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Purchasing Detail</h4>
                        <div class="form-inline">
                            <div class="button-group">
                                <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                                <i class="fa fa-filter" aria-hidden="true"></i>
                                    Filter
                                    <span class="caret"></span>
                                </button>
                                <ul class="dropdown-menu p-2" >
                                <span>Company:</span>
                                <div class="dropdown-divider"></div>
                                <li v-for="ct in companyList" :key="ct.id">
                                    <a href="#" class="small" tabIndex="-1">
                                    <input type="checkbox" :value="ct.company_no" v-model="filterCompany"/>&nbsp; {{ ct.name }}
                                    </a>
                                </li>
                                </ul>
                            </div>
                            <button class="btn btn-success btn-sm btn-soft-outline-primary dropdown-toggle" type="button" id="action" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action</button>
                            <div class="dropdown-menu" aria-labelledby="action">
                                <a class="dropdown-item" href="javascript:void(0)" @click="setCOGS">Set COGS</a>
                            </div>
                            <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                                <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                            </button>
                            <div class="form-group mx-sm-3 mb-2">
                                <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                            </div>
                            <div class="button-group">
                                <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                                rows:
                                <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                                <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                                </select>
                                <span class="mr-1">
                                Total rows: <b>{{ rowsTotal }}</b>
                                </span>
                            </div>
                            <span class="mr-1 ml-1">
                                page:
                                <select v-model="currentPage">
                                <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                                </select>
                                / {{ pageLength }}
                            </span>
                            <nav aria-label="Page navigation example" class="pull-right">
                                <ul class="pagination">
                                    <li class="page-item">
                                        <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                            <i class="fa fa-angle-left" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                    <li class="page-item">
                                        <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-small-list">
                    <div class="card-body">
                    <div class="table-responsive">
                        <span class="pull-right mb-2 font-14" style="font-weight: 800"><i class="fa fa-cart-plus" aria-hidden="true"></i> Total: {{ totalOutstanding | currency }}</span>
                        <table class="table table-item mb-0 table-sm table-hover">
                            <thead>
                                <tr>
                                    <th>
                                    <label class="form-checkbox">
                                        <input type="checkbox" v-model="selectAll" @click="select">
                                        <i class="form-icon"></i>
                                    </label>
                                    </th>
                                    <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                                        {{ t.name }}
                                        <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="filterData.length < 1">
                                    <td colspan="14" style="text-align: center;"><i>No Data</i></td>
                                </tr>
                                <tr v-for="u in filterData" v-bind:key="u.id">
                                    <td>
                                        <label class="form-checkbox">
                                        <input type="checkbox" :value="u.id" v-model="selected">
                                        <i class="form-icon"></i>
                                        </label>
                                    </td>
                                    <td>
                                        <span class="badge badge-success" v-if="u.status === 'approved'">{{ u.status }}</span>
                                        <span class="badge badge-warning" v-else>{{ u.status }}</span>
                                    </td>
                                    <td>
                                        <span style="cursor: pointer" @click="getSaleNo(u.purchasing_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false"><b>{{ u.purchasing_no }}</b></span>
                                    </td>
                                    <td>{{ u.company }}</td>
                                    <td>{{ u.purchasing_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td><b>[{{ u.product_no }}]</b> {{ u.description }}</td>
                                    <td class="text-right">{{ u.qty | currency }}</td>
                                    <td>{{ u.uom_id }}</td>
                                    <td class="text-right">{{ u.price | currency }}</td>
                                    <td class="text-right">{{ u.discount | currency }}</td>
                                    <td class="text-right">{{ u.subtotal | currency }}</td>
                                    <td class="text-right">{{ u.tax | currency }}</td>
                                    <td class="text-right">{{ u.total | currency }}</td>
                                    <td>
                                        <button class="btn btn-sm btn-hard-primary" data-toggle="modal" data-target="#modalProductCost" data-backdrop="static" data-keyboard="false" @click="getCOGS(u.product_no, u.company_no)">COGS</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <ProductCostListModal :company="company"/>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { productUrl, purchasingUrl, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'
import ProductCostListModal from '@/components/product/ProductCostListModal.vue'

export default {
  name: 'PurchasingDetailList',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker,
    ProductCostListModal
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      filterCompany: [],
      startDate: [date1, date2],
      dateNow: new Date(),
      company: null,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status',
        align: 'text-left'
      }, {
        name: 'Purchasing No.',
        prop: 'purchasing_no',
        align: 'text-left'
      }, {
        name: 'Company',
        prop: 'company',
        align: 'text-left'
      }, {
        name: 'Date',
        prop: 'purchasing_date',
        align: 'text-left'
      }, {
        name: 'Product',
        prop: 'product_no',
        align: 'text-left'
      }, {
        name: 'Qty',
        prop: 'qty',
        align: 'text-right'
      }, {
        name: 'Uom',
        prop: 'uom_id',
        align: 'text-left'
      }, {
        name: 'Price',
        prop: 'price',
        align: 'text-right'
      }, {
        name: 'Discount',
        prop: 'discount',
        align: 'text-right'
      }, {
        name: 'Subtotal',
        prop: 'subtotal',
        align: 'text-right'
      }, {
        name: 'Tax',
        prop: 'tax',
        align: 'text-right'
      }, {
        name: 'Total',
        prop: 'total',
        align: 'text-right'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList
    }),
    totalOutstanding () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    getCOGS (product, company) {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var payload = {
        begin: begin,
        end: end,
        product_no: product,
        company_no: company
      }
      console.log(payload)
      this.company = company
      this.$store.dispatch('getProductCogsByNo', payload)
    },
    async setCOGS () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selected
      var resp = {
        error: false,
        message: null
      }
      for (let i = 0; i < array.length; i++) {
        const detail = this.dataRaw.find(d => d.id === array[i])
        var data = {
          date: detail.purchasing_date,
          product_no: detail.product_no,
          type: 'all',
          company_no: detail.company_no
        }
        console.log(data)
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response.data.message)
            this.$swal('Error', error.response.data.message + '[' + detail.product_no + ']', 'error')
            this.$Progress.finish()
            this.loader.isLoading = false
            throw error
          })
      }
      if (resp.error === false) {
        await this.$Progress.finish()
        this.loader.isLoading = false
        this.selected = []
        this.selectAll = false
        await this.$swal('Success', resp.message, 'success')
      }
    },
    getSaleNo (saleNo) {
      var payload = {
        sale_no: saleNo
      }
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: null
      }
      axios.post(purchasingUrl + '/detail/list', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
          window.scrollTo(0, this.scroll)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('succcess', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>
